import './OverflowCell.553a2040703f9c7ee944aeb2d9a4d25f.css';
export default {"overflowCell":"_overflowCell_10n9b_1"};